export default __webpack_public_path__ + "static/media/wall_login_bg.f130e228.png";